import CompoundViewTable from "./CompoundViewTable";
export default CompoundViewTable;